import React from 'react';
import { Box, Typography } from '@mui/material';

const PlannerDiscussionMessages = ({ messages }) => {
  console.log('?? Rendering PlannerDiscussionMessages. Received messages:', messages);

  if (!Array.isArray(messages)) {
    return <Typography color="error">?? Messages prop is not an array</Typography>;
  }

  if (messages.length === 0) {
    return <Typography>No discussion messages yet.</Typography>;
  }

  return (
    <>
      {messages.map((msg, index) => (
        <Box
          key={index}
          mb={2}
          p={1}
          bgcolor={msg.sender === 'user' ? 'grey.100' : 'blue.50'}
          borderRadius={2}
        >
          <Typography variant="body2" color="textSecondary" fontWeight="bold">
            {msg.sender === 'user' ? 'You:' : 'Agent:'}
          </Typography>
          <Typography variant="body1" color="black">
            {msg.message || '(empty)'}
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default PlannerDiscussionMessages;
